/* eslint-disable no-restricted-imports */
import React, { useEffect, useState, useCallback } from "react";
import {
  InputLabel,
  Button,
  RadioGroup,
  Radio,
  Checkbox,
  FormControlLabel
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Toast, Col, Row } from "react-bootstrap";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { v4 as uuidv4 } from "uuid";
import { ToastContainer, toast } from "react-toastify";
import { toAbsoluteUrl } from "../../_metronic/_helpers";
import { GroupList } from "./GroupList";
import { GroupEdit } from "./GroupEdit";
import {
  getUserListData,
  getAllQuotaUsage,
  getAllDistributionList,
  getUserListByGroup,
  deleteGroup
} from "../modules/Auth/_redux/adminCrud";

export function GroupPage({ history }) {
  const useStyles = makeStyles(theme => ({
    popLabelStyle: {
      display: "inline-block",
      //   marginTop: "-2px",
      textAlign: "left",
      fontSize: "1rem",
      width: "136px",
      height: "34px"
      //   borderRight: "1px solid #c8cace"
    },
    popInputSmallStyle: {
      display: "inline-block",
      marginLeft: "8px",
      fontSize: "1rem",
      width: "40px",
      height: "24px",
      borderRadius: "4px 4px 4px 4px",
      border: "1px solid #c8cace"
    },
    popInputStyle: {
      display: "inline-block",
      marginTop: "-2px",
      fontSize: "1rem",
      width: "80px",
      height: "24px",
      borderRadius: "4px 4px 4px 4px",
      border: "1px solid #c8cace"
    },
    popInputLongStyle: {
      display: "inline-block",
      marginTop: "-2px",
      fontSize: "1rem",
      width: "300px",
      height: "24px",
      borderRadius: "4px 4px 4px 4px",
      border: "1px solid #c8cace"
    },
    labelStyle: {
      display: "inline-block",
      marginTop: "-2px",
      fontSize: "1rem",
      width: "160px"
    },
    inputStyle: {
      display: "inline-flex",
      width: "200px",
      height: "24px",
      border: "1px solid #c8cace",
      paddingLeft: "8px",
      borderRadius: "4px 4px 4px 4px",
      ":active": {
        border: "1px solid #c8cace"
      }
    },
    selectStyle: {
      display: "inline-flex",
      width: "200px",
      height: "32px",
      border: "1px solid #c8cace",
      paddingLeft: "8px",
      background: "transparent",
      marginRight: "12px",
      borderRadius: "4px 4px 4px 4px",
      ":active": {
        background: "transparent"
      }
    },
    treeContainerStyle: {
      display: "inline-block",
      width: "calc(20% - 12px)",
      border: "1px solid #c8cace",
      borderRadius: "4px 4px 4px 4px",
      marginRight: "12px",
      verticalAlign: "top"
    },
    listContainerStyle: {
      display: "inline-block",
      width: "100%",
      border: "1px solid #c8cace",
      borderRadius: "4px 4px 4px 4px"
    },
    inputStyle: {
      display: "inline-flex",
      width: "200px",
      height: "32px",
      border: "1px solid #c8cace",
      paddingLeft: "8px",
      borderRadius: "2px 2px 2px 2px",
      ":active": {
        border: "1px solid #c8cace"
      }
    },
    buttonStyle: {
      width: "120px",
      height: "32px",
      color: "#123456",
      border: "1px solid #123456",
      fontSize: "1.2rem",
      marginRight: "12px"
    },
    buttonSmallStyle: {
      width: "60px",
      height: "28px",
      color: "#123456",
      border: "1px solid #123456",
      fontSize: "1rem"
      //   marginLeft: "12px"
    },

    buttonDisableStyle: {
      color: "#b4b5b8",
      border: "1px solid #b4b5b8",
      background: "#ebedf1"
    },
    buttonClearStyle: {
      width: "32px",
      height: "32px",
      border: "0px solid #123456",
      marginRight: "12px",
      "&:hover": {
        backgroundColor: "transparent !important"
      }
    },
    searchStyle: {
      width: "120px",
      height: "32px",
      color: "#123456",
      border: "1px solid #123456",
      fontSize: "1rem",
      float: "right"
    },
    dateStyle: {
      width: "160px",
      height: "32px",
      color: "#123456",
      border: "1px solid #c8cace",
      fontSize: "1rem",
      marginRight: "36px",
      textAlign: "left",
      background: "transparent",
      borderRadius: "4px 4px 4px 4px",
      paddingLeft: "12px"
    },

    boxContainer: {
      display: "inline-block",
      width: "100%",
      verticalAlign: "top"
    },
    box30Style: {
      width: "100%",
      display: "inline-block",
      background: "white",
      border: "1px solid #c8cace",
      padding: "24px",
      marginBottom: "12px"
    },
    boxStyle: {
      width: "100%",
      display: "inline-block",
      background: "white",
      border: "1px solid #c8cace",
      padding: "24px",
      marginBottom: "12px"
    },
    subTitleStyle: {
      display: "block",
      fontSize: "1rem",
      width: "100%",
      marginBottom: "12px",
      fontWeight: "bold",
      alignItems: "baseline",
      color: "#555555"
    },
    subTitleInnerStyle: {
      display: "block",
      fontSize: "1rem",
      width: "100%",
      margin: "12px",
      fontWeight: "bold",
      alignItems: "baseline",
      color: "#555555"
    },

    subTitleLastStyle: {
      fontSize: "1rem",
      //   fontWeight: "bold",
      color: "#555555",
      marginTop: "-8px"
    },
    subTitlePopStyle: {
      fontSize: "1rem",
      color: "#555555",
      margin: "4px"
    },
    subTitlePopLineStyle: {
      fontSize: "1rem",
      color: "#555555",
      margin: "4px",
      height: "32px"
      //   borderBottom: "1px solid #c8cace"
    },
    headerRowStyle: {
      display: "flex",
      textAlign: "center",
      width: '100%',
      height: "44px",
      lineHeight: "44px"
    },
    headerColStyle: {
      display: "inline-block",
      fontSize: "1rem",
      fontWeight: "bold",
      textAlign: "center",
      width: "50%",
      background: "#dfe2e8",
      height: "44px"
    },
    headerCol100Style: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "100%",
      background: "#dfe2e8",
      height: "44px"
    },
    headerCheckboxStyle: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "44px",
      background: "#dfe2e8",
      height: "44px"
    },
    dataCheckboxStyle: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "44px",
      //   background: "#dfe2e8",
      height: "44px"
    },
    dataRowStyle: {
      display: "flex",
      textAlign: "center",
      height: "44px",
      lineHeight: "44px",
      borderBottom: "1px solid #c8cace"
    },
    width100Style: {
      width: "100%"
    },
    dataColStyle: {
      display: "inline-block",
      fontSize: "1rem",
      textAlign: "center",
      width: "50%",
      height: "44px",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflow: "hidden"
    },
    dataCol100Style: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "100%",
      height: "44px"
    },
    dataColSmallStyle: {
      display: "inline-block",
      fontSize: "12px",
      textAlign: "center",
      width: "50%",
      height: "44px",
      overflow: "hidden",
      lineHeight: "16px",
      paddingTop: "6px"
    },
    dataColTextStyle: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "left",
      //   width: "50%",
      height: "44px"
    },
    radioStyle: {
      width: "80px",
      fontSize: "1rem",
      //   background: "transparent",
      color: "#555555",
      borderColor: "#dfe2e8",
      //   paddingTop: "6px",
      //   "&:hover": {
      //     color: "#123456",
      //     backgroundColor: "#eae4f5 !important"
      //   },
      "&:active": {
        color: "white",
        backgroundColor: "#123456 !important"
      }
    },
    selected: {
      color: "white",
      backgroundColor: "#123456 !important"
    }
  }));

  const [distributeList, setDistributeList] = useState([]);

  const Styles = useStyles();
  const [refresh, setRefresh] = React.useState(false);
  const [showAsk, setShowAsk] = React.useState(false);
  const [showNew, setShowNew] = React.useState(false);
  // const [showToast, setShowToast] = React.useState(false);
  const [editTitle, setEditTitle] = React.useState("");
  const [editIP, setEditIP] = React.useState("");
  const [editDesc, setEditDesc] = React.useState("");

  const [showGroup, setShowGroup] = React.useState(false);
  const [editMode, setEditMode] = React.useState("NEW");
  const [editUserData, setEditUserData] = React.useState();
  const [selectedGroup, setSelectedGroup] = React.useState();
  const [userList, setUserList] = useState([]);
  const checkIpAddress = () => {
    return true;
  };

  const formatBytes = (bytes = 0, fixed) => {
    const marker = 1024; // Change to 1000 if required
    const decimal = fixed != null ? fixed : 2; // Change as required
    const kiloBytes = marker; // One Kilobyte is 1024 bytes
    const megaBytes = marker * marker; // One MB is 1024 KB
    const gigaBytes = marker * marker * marker; // One GB is 1024 MB
    // const teraBytes = marker * marker * marker * marker; // One TB is 1024 GB

    // return bytes if less than a KB
    if (bytes == null || bytes < kiloBytes) {
      return `${bytes}B`;
      // return KB if less than a MB
    }
    if (bytes < megaBytes) {
      return `${(bytes / kiloBytes).toFixed(decimal)}KB`;
      // return MB if less than a GB
    }
    if (bytes < gigaBytes) {
      return `${(bytes / megaBytes).toFixed(decimal)}MB`;
      // return GB if less than a TB
    }

    return `${(bytes / gigaBytes).toFixed(decimal)}GB`;
  };

  const handlePressDelete = () => {
    setShowAsk(true);
  };

  const getAllDistributionListInfo = () => {
    let dls = [];
    getAllDistributionList("brainary.io").then(result => {
      result.data.distributionInfo.forEach(dist => {
        console.log("getAllDistributionList", dist.name, dist);

        const dpName = dist.a.filter(a => a.n === "displayName");

        dls.push({
          id: dist.id,
          dlEmail: dist.name,
          dlName: dpName != null && dpName.length > 0 ? dpName[0]._content : "",
          mailQuota: "0B/무제한",
          members: dist.members,
          count: dist.members?.length
        });
      });

      setDistributeList(dls);
    })
    .catch(error => {
      console.log(error)
    })
  };

  const handleOrgDeptSelected = dept => {};

  const deleteGroupInfo = () => {
    deleteGroup(selectedGroup.groupCode).then(result => {
      console.log("deleteGroupInfo", result);

      if (result.code === 200) {
        toast("삭제되었습니다.");
        setRefresh(!refresh);
        // window.location.reload();
        history.push('');
        history.push('/group');
      } else toast("서버 오류가 발생했습니다.");
    })
    .catch(error => {
      console.log(error)
    })
  };

  const handlePressModifyGroup = group => {
    if (selectedGroup.groupCode === 77777) return;

    group.memberList = userList;
    setEditMode("MODIFY");
    setEditUserData(group);
    setShowGroup(true);
  };

  const handleGroupEnrolled = group => {
    getUserListByGroup(group.groupCode).then(data => {
      console.log("USERS", data);
      if (data.data.users != null) {
        data.data.users.map(user => {
          user.status = "활성";
          user.level = "사용자";
          user.checked = false;
          user.mailQuota = `${formatBytes(user.used)} / ${
            user.limit > 0 ? formatBytes(user.limit) : "무제한"
          }`;
          user.date = user.createDt.split("T")[0];
        });

        let users = data.data.users;
        // if (searchName !== "")
        //   users = data.data.users.filter(
        //     user => user.name.indexOf(searchName) >= 0
        //   );

        console.log("FILTERED", users);

        setUserList(users);
        // if (dept != null) setDeptName(dept.deptName);
        // setDeptUserCount(`(${users.length}명)`);
        setRefresh(!refresh);
      }
    })
    .catch(error => {
      console.log(error)
    })
  };

  const handleGroupUnenrolled = () => {
    const anonymous = [];
    getAllQuotaUsage().then(result => {
      console.log("Zimbra Accounts", result.data.quotaUsage);

      getUserListData(null).then(result1 => {
        console.log("USERS", result1.data.users);
        if (result1.data.users != null) {
          for (var aa = 0; aa < result.data.quotaUsage.length; aa += 1) {
            let found = false;
            for (var ii = 0; ii < result1.data.users.length; ii += 1) {
              if (
                result1.data.users[ii].email === result.data.quotaUsage[aa].name
              ) {
                found = true;
                break;
              }
            }

            if (!found)
              anonymous.push({
                userId: result.data.quotaUsage[aa].name,
                name: result.data.quotaUsage[aa].name.split("@")[0],
                status: "활성",
                teamName: "미분류",
                mailQuota: `${formatBytes(result.data.quotaUsage[aa].used)} / ${
                  result.data.quotaUsage[aa].limit > 0
                    ? formatBytes(result.data.quotaUsage[aa].limit)
                    : "무제한"
                }`
              });
          }

          console.log("ANONYMOUS", anonymous);
          setUserList(anonymous);
          setRefresh(!refresh);
        }
      })
      .catch(error => {
        console.log(error)
      })
    .catch(error => {
      console.log(error)
    })
    })
    .catch(error => {
      console.log(error)
    })
  };

  const handleGroupSelected = group => {
    console.log("handleGroupSelected", group);
    setSelectedGroup(group);

    if (group.groupCode === 77777) handleGroupUnenrolled();
    else handleGroupEnrolled(group);

    setRefresh(!refresh);
  };

  useEffect(() => {}, [refresh, selectedGroup]);

  return (
    <>
      <ToastContainer />
      <div
        style={{
          marginTop: "12px",
          marginLeft: "-12px",
          height: "100%"
        }}
      >
        {/* -------------------- */}

        <div className={Styles.boxContainer}>
          <div className={Styles.boxStyle}>
            <div className={Styles.treeContainerStyle}>
              <GroupList height="742px" onClick={handleGroupSelected} />
            </div>

            <div style={{ display: "inline-block", width: "80%" }}>
              <div className={Styles.listContainerStyle}>
                <div className={Styles.subTitleInnerStyle}>
                  {selectedGroup?.groupName || ' '}
                  <div
                    style={{
                      display: "inline-flex",
                      float: "right",
                      marginRight: "32px",
                      marginTop: "-4px"
                    }}
                  >
                    <Button
                      className={[
                        Styles.buttonSmallStyle,
                        selectedGroup?.groupCode === 77777 &&
                          Styles.buttonDisableStyle
                      ]}
                      onClick={() => {
                        if (selectedGroup?.groupCode === 77777) return;
                        setEditMode("NEW");
                        setEditUserData(null);
                        setShowGroup(true);
                      }}
                    >
                      추가
                    </Button>
                    &nbsp;&nbsp;
                    <Button
                      className={[
                        Styles.buttonSmallStyle,
                        selectedGroup?.groupCode === 77777 &&
                          Styles.buttonDisableStyle
                      ]}
                      onClick={() => {
                        if (selectedGroup?.groupCode === 77777) return;
                        handlePressDelete();
                        // setShowToast(true);
                      }}
                    >
                      삭제
                    </Button>
                  </div>
                </div>
                <div className={Styles.headerRowStyle}>
                  <div className={Styles.headerColStyle}>그룹명</div>
                  <div className={Styles.headerColStyle}>대표아이디</div>
                  <div className={Styles.headerColStyle}>메일 용량</div>
                  <div className={Styles.headerColStyle}>계정수</div>
                  <div className={Styles.headerColStyle}>수정</div>
                </div>

                <div className={Styles.dataRowStyle} key={uuidv4()}>
                  <div className={Styles.dataColStyle}>
                    {selectedGroup?.groupName}
                  </div>
                  <div className={Styles.dataColStyle}>
                    {selectedGroup?.groupEmail}
                  </div>
                  <div className={Styles.dataColStyle}>
                    {selectedGroup?.mailQuota === 0
                      ? "무제한"
                      : formatBytes(selectedGroup?.mailQuota)}
                  </div>
                  <div className={Styles.dataColStyle}>{userList.length}</div>
                  <div className={Styles.dataColStyle}>
                    <Button
                      className={[
                        Styles.buttonSmallStyle,
                        selectedGroup?.groupCode === 77777 &&
                          Styles.buttonDisableStyle
                      ]}
                      onClick={() => {
                        handlePressModifyGroup(selectedGroup);
                      }}
                    >
                      수정
                    </Button>
                  </div>
                </div>
              </div>

              <div
                className={Styles.listContainerStyle}
                style={{
                  marginTop: "12px"
                }}
              >
                <div>
                  <div className={Styles.headerRowStyle}>
                    <div className={Styles.headerColStyle}>아이디</div>
                    <div className={Styles.headerColStyle}>이름</div>
                    {/* <div className={Styles.headerColStyle}>상태</div> */}
                    <div className={Styles.headerColStyle}>부서</div>
                    <div className={Styles.headerColStyle}>메일 사용량</div>
                    <div className={Styles.headerColStyle}>등록일</div>
                  </div>
                  <div
                    style={{
                      height: "calc(640px - 44px)",
                      overflowY: "scroll"
                    }}
                  >
                    {userList.length === 0 && (
                      <div style={{ textAlign: "center", marginTop: "48px" }}>
                        이 메일그룹에 등록된 조직원이 없습니다.
                      </div>
                    )}

                    {userList.map(user => (
                      <div className={Styles.dataRowStyle} key={uuidv4()}>
                        <div className={Styles.dataColStyle}>{user.userId}</div>
                        <div className={Styles.dataColStyle}>{user.name}</div>
                        {/* <div className={Styles.dataColStyle}>{user.status}</div> */}
                        <div className={Styles.dataColStyle}>
                          {user.teamName}
                        </div>
                        <div className={Styles.dataColStyle}>
                          {user.mailQuota}
                        </div>
                        <div className={Styles.dataColStyle}>{user.date}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Dialog
        open={showAsk}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"삭제"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            선택한 항목을 삭제하시겠습니까?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            onClick={() => {
              setShowAsk(false);
              // setShowToast(true);
            }}
          >
            아니오
          </Button>
          <Button
            color="primary"
            autoFocus
            onClick={() => {
              setShowAsk(false);
              deleteGroupInfo();
            }}
          >
            예
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showNew}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{editTitle}</DialogTitle>
        <DialogContent>
          {/* <DialogContentText id="alert-dialog-description">
            선택한 항목을 삭제하시겠습니까?
          </DialogContentText> */}
          <div>
            <div style={{ display: "inline-flex", width: "50px" }}>
              IP <span style={{ color: "red" }}>&nbsp;&nbsp;*</span>
            </div>
            <input
              type="text"
              value={editIP}
              className={Styles.inputStyle}
              onChange={e => {
                console.log("IP", e.target.value);
                setEditIP(e.target.value);
              }}
            ></input>
          </div>
          <div style={{ marginTop: "12px" }}>
            <div style={{ display: "inline-flex", width: "50px" }}>비고</div>
            <input
              type="text"
              value={editDesc}
              className={Styles.inputStyle}
              name="phone"
              onChange={e => {
                console.log("DESC", e.target.value);
                setEditDesc(e.target.value);
              }}
            ></input>
          </div>
        </DialogContent>
        <DialogActions>
          <div
            style={{ width: "100%", textAlign: "center", paddingBottom: "8px" }}
          >
            <Button
              className={Styles.buttonSmallStyle}
              onClick={() => {
                // setShowNew(false);
              }}
            >
              취소
            </Button>
            <Button
              style={{ marginLeft: "24px" }}
              className={[
                Styles.buttonSmallStyle,
                !checkIpAddress() && Styles.buttonDisableStyle
              ]}
              autoFocus
              onClick={() => {
                setShowNew(false);
              }}
            >
              저장
            </Button>
          </div>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showGroup}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <GroupEdit
          mode={editMode}
          userData={editUserData}
          parentGroupCode={selectedGroup?.parentGroupCode}
          groupCode={selectedGroup?.groupCode}
          groupLevel={selectedGroup?.groupLevel}
          onCancel={() => setShowGroup(false)}
          onApply={(groupEmail) => {
            setShowGroup(false);

            toast("저장되었습니다.");
            selectedGroup.groupEmail = groupEmail;
            handleGroupSelected(selectedGroup);

            history.push('');
            history.push('/group');
          }}
        />
      </Dialog>

    </>
  );
}
